module.exports = __webpack_public_path__ + "img/m2.df0c302.jpg";